import React from "react";
import { Box, Typography } from "@mui/material";

function FieldList({ rows }) {
  return (
    <Box sx={{ mb: 2 }}>
      {rows.map((row) => (
        <Box
          key={row.label}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
            py: 0.6,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {row.label}
          </Typography>
          <Typography variant="body2" sx={{ textAlign: "right" }}>
            {row.value ?? "—"}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default FieldList;
